function toNumber(value, fallback = 0) {
  const num = Number(value);
  return Number.isNaN(num) ? fallback : num;
}

export function parseApiLeaveSummary(apiSummary, options = {}) {
  const { lopUsedFallback = 0 } = options;
  const earnedLeave = {
    total: toNumber(apiSummary?.earned_leave?.total),
    used: toNumber(apiSummary?.earned_leave?.used),
    remaining: toNumber(apiSummary?.earned_leave?.remaining),
  };
  const sickLeave = {
    total: toNumber(apiSummary?.sick_leave?.total),
    used: toNumber(apiSummary?.sick_leave?.used),
    remaining: toNumber(apiSummary?.sick_leave?.remaining),
  };
  const casualLeave = {
    total: toNumber(apiSummary?.casual_leave?.total),
    used: toNumber(apiSummary?.casual_leave?.used),
    remaining: toNumber(apiSummary?.casual_leave?.remaining),
  };
  const lopApi = apiSummary?.loss_of_pay || apiSummary?.lop_leave || null;
  const lopUsed =
    lopApi?.used != null ? toNumber(lopApi.used) : toNumber(lopUsedFallback);
  const lopTotal = toNumber(lopApi?.total);
  const lopRemaining =
    lopApi?.remaining != null
      ? toNumber(lopApi.remaining)
      : Math.max(lopTotal - lopUsed, 0);
  const lopLeave = {
    total: lopTotal,
    used: lopUsed,
    remaining: lopRemaining,
  };

  const total = earnedLeave.total + sickLeave.total + casualLeave.total + lopLeave.total;
  const used = earnedLeave.used + sickLeave.used + casualLeave.used + lopLeave.used;
  const remaining =
    earnedLeave.remaining + sickLeave.remaining + casualLeave.remaining + lopLeave.remaining;

  return {
    total,
    used,
    remaining,
    earnedLeave,
    sickLeave,
    casualLeave,
    lopLeave,
  };
}

export function formatLeaveCount(value) {
  const num = Number(value);
  if (Number.isNaN(num)) return '0';
  return Number.isInteger(num) ? String(num) : String(num);
}

const DAY_TYPE_LABELS = {
  full_day: 'Full Day',
  first_half: 'First Half',
  second_half: 'Second Half',
};

export function formatDayTypeLabel(value) {
  const key = String(value || '').trim().toLowerCase();
  if (!key) return '-';
  if (DAY_TYPE_LABELS[key]) return DAY_TYPE_LABELS[key];
  return key.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());
}
